import React, { Component } from "react";
import PropTypes from "prop-types";

class Editor extends Component {
  constructor(props) {
    super(props);
    this.editor = null;
    this.state = {
      code: "",
      language: "javascript",
      theme: "vs-dark"
    };
  }

  // @todo: Use typescript to handle propTypes via monaco.d.ts
  // (https://github.com/Microsoft/monaco-editor/blob/master/monaco.d.ts):
  static propTypes = {
    // Styles props:
    // style: PropTypes.object,
    className: PropTypes.string,
    // height: PropTypes.number,
    // width: PropTypes.number,
    height: PropTypes.string,
    width: PropTypes.string,
    //code value
    value: PropTypes.string,

    // Preferences props:
    language: PropTypes.string,
    theme: PropTypes.string,

    // Lifecycle props:
    didLoad: PropTypes.func,
    didMount: PropTypes.func,
    onValueChange: PropTypes.func
  };
  static defaultProps = {
    // width: 600, // auto
    width: "99%",
    height: "100%",
    // width: 900,
    // height: 800,
    language: "",
    wordWrap: "on",
    // language: "go",
    theme: "vs-dark",
    //theme: "vs-light",
    didLoad: () => {},
    didMount: () => {}
  };

  componentDidMount() {
    this.handleLoad();
  }

  componentDidUpdate(prevProps) {
    // console.log(
    //   "Editor updated - language -> ",
    //   this.props.selectedLanguage,
    //   " theme: ",
    //   this.props.selectedTheme
    // );

    // console.log(
    //   "editor -> componentDidUpdate -> this.props.selectedLanguage: ",
    //   this.props.selectedLanguage
    // );
    if (prevProps.selectedLanguage !== this.props.selectedLanguage) {
      this.setState({ language: this.props.selectedLanguage });
      window.monaco.editor.setModelLanguage(
        this.editor.getModel(),
        this.props.selectedLanguage.toLowerCase()
      );
    }

    if (prevProps.selectedTheme !== this.props.selectedTheme) {
      this.setState({ theme: this.props.selectedTheme });
      window.monaco.editor.setTheme(this.props.selectedTheme);
    }

    //this is used by create-aource; multi-file approach uses pushEditorOperations
    if (prevProps.value !== this.props.value) {
      this.setState({ value: this.props.value });
      const model = this.editor.getModel();
      model.setValue(this.props.value);
    }
  }

  containerDidMount = ref => {
    this.ref = ref;
  };

  handleLoad() {
    // @note: safe to not check typeof window since it'll call on componentDidMount lifecycle:
    if (!window.require) {
      const loaderScript = window.document.createElement("script");
      loaderScript.type = "text/javascript";
      // @note: Due to the way AMD is being used by Monaco, there is currently no graceful way to integrate Monaco into webpack (cf. https://github.com/Microsoft/monaco-editor/issues/18):
      //loaderScript.src = "https://unpkg.com/monaco-editor/min/vs/loader.js";
      loaderScript.src =
        "https://cdn.jsdelivr.net/npm/monaco-editor@0.17.1/min/vs/loader.js";

      loaderScript.addEventListener("load", this.didLoad);
      window.document.body.appendChild(loaderScript);
    } else {
      this.didLoad();
    }
  }

  handleMount() {
    let { language, theme } = this.props;
    window.monaco.languages.typescript.javascriptDefaults.setDiagnosticsOptions(
      {
        noSemanticValidation: true,
        noSyntaxValidation: false
      }
    );

    // compiler options
    window.monaco.languages.typescript.javascriptDefaults.setCompilerOptions({
      target: window.monaco.languages.typescript.ScriptTarget.ES6,
      allowNonTsExtensions: true,
      allowJs: true,
      allowSyntheticDefaultImports: true,
      //alwaysStrict: true,
      jsx: "React",
      jsxFactory: "React.createElement"
    });

    // extra libraries
    window.monaco.languages.typescript.javascriptDefaults.addExtraLib(
      [
        "declare class SomeEventType {",
        "    /**",
        "     * Heres the doco for someProperty",
        "     */",
        "    someProperty: string",
        "}"
      ].join("\n"),
      "filename/facts.d.ts"
    );
    //language = selectedLanguage.toLowerCase();
    language = this.props.selectedLanguage.toLowerCase();
    //console.log("editor -> selectedLanguage: ", language);
    const editor = window.monaco.editor.create(this.ref, {
      value: "", //initial value
      language,
      theme,
      fontSize: "12px",
      scrollbar: {
        useShadows: false,
        verticalHasArrows: true,
        horizontalHasArrows: true,
        vertical: "visible",
        horizontal: "visible",
        verticalScrollbarSize: 7,
        horizontalScrollbarSize: 7,
        arrowSize: 30
      },
      minimap: {
        enabled: false
      },
      wordWrap: "on",
      automaticLayout: true
    });
    // GR added this line
    this.editor = editor;

    const model = editor.getModel();
    window.monaco.editor.setModelLanguage(model, language);
    this.setState({ code: editor.getValue() });
    //console.log("editor code: ", this.state.code);

    this.didMount(editor);
    //added for course authoring in markdown - used in create-course.js
    model.onDidChangeContent(() => {
      const value = model.getValue();

      this.props.onValueChange(value);
    });

    return editor;
  }

  didMount = editor => {
    const { didMount } = this.props;
    //console.log("editor mounted -> lang: ", this.props.selectedLanguage);
    didMount(editor);
  };

  didLoad = e => {
    const { didLoad } = this.props;
    window.require.config({
      //paths: { vs: "https://unpkg.com/monaco-editor/min/vs" }
      paths: { vs: "https://cdn.jsdelivr.net/npm/monaco-editor@0.17.1/min/vs" }
    });
    window.require(["vs/editor/editor.main"], () => {
      this.handleMount();
    });

    didLoad();

    if (e) {
      e.target.removeEventListener("load", this.didLoad);
    }
  };

  render() {
    let { className, style, width, height } = this.props;
    // height = 500
    // width = 900
    return (
      <div
        ref={this.containerDidMount}
        className={className}
        style={{
          height,
          width,
          ...style
        }}
      />
    );
  }
}

export default Editor;
